module.exports = __webpack_public_path__ + "static/media/lawsuit.257a8e90.svg";